import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";

import { localApi, credentials } from "utils/imgApi";
import { getStates, getCities } from "utils/util";

import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import EmailIcon from "@material-ui/icons/Email";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Face from "@material-ui/icons/Face";
import BusinessIcon from "@material-ui/icons/Business";
import Check from "@material-ui/icons/Check";

import Axios from "axios";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import stylesCli from "assets/jss/material-dashboard-pro-react/views/viewCartStyle";
import styles from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styl from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";

import SweetAlert from "react-bootstrap-sweetalert";

const useStylesCli = makeStyles(stylesCli);
const useStyles = makeStyles(styles);
const useSweetAlertStyles = makeStyles(style);
const useDropdownStyles = makeStyles(styl);

function ErrorMessage({ message }) {
  if (!message) {
    return null;
  }

  return (
    <span
      style={{
        display: "block",
        color: "red",
        marginLeft: "12px",
        marginTop: "4px",
      }}
    >
      {message}
    </span>
  );
}

const initialForm = {
  firstName: "",
  lastName: "",
  mobile: "",
  mobileWhatsapp: "",
  company: "",
  email: "",
  state: "",
  city: "",
  url: "",
  active: false,
};

const initialRegisteredStatus = {
  mobile: false,
  mobileWhatsapp: false,
  email: false,
};

export default function CrmContact() {
  const classes = useStyles();
  const classesCli = useStylesCli();
  const alertClasses = useSweetAlertStyles();
  const dropdownClasses = useDropdownStyles();

  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  const [countryCodeList, setCountryCodeList] = useState([]);
  const [countryCode, setCountryCode] = useState("in");
  const [stateCode, setStateCode] = useState("");

  const [client, setClient] = useState([]);
  const [typeList, setTypeList] = useState([]);

  const [loadingTypes, setLoadingTypes] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [simpleTypeSelect, setSimpleTypeSelect] = useState("");

  const [clientid, setClientid] = useState(null);
  const [clientId, setClientId] = useState("");

  const [alert, setAlert] = useState({
    open: false,
    type: "success",
    message: "",
  });

  const [registeredStatus, setRegisteredStatus] = useState(
    initialRegisteredStatus,
  );

  // Used to ignore old responses when the user changes a value quickly.
  const validationRequestIds = useRef({
    mobile: 0,
    mobileWhatsapp: 0,
    email: 0,
  });

  const states = useMemo(() => {
    return getStates(countryCode) || [];
  }, [countryCode]);

  const cities = useMemo(() => {
    return getCities(countryCode, stateCode) || [];
  }, [countryCode, stateCode]);

  const updateField = (field, value) => {
    setForm((previous) => ({
      ...previous,
      [field]: value,
    }));

    setErrors((previous) => ({
      ...previous,
      [field]: "",
    }));
  };

  const showAlert = (type, message) => {
    setAlert({
      open: true,
      type,
      message,
    });
  };

  const closeAlert = () => {
    setAlert({
      open: false,
      type: "success",
      message: "",
    });
  };

  const getClient = async () => {
    try {
      const api = `${localApi}/clientGroup/allList`;

      const result = await fetch(api, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
          Accept: "application/json",
        },
      });

      if (!result.ok) {
        throw new Error("Unable to load clients.");
      }

      const getResult = await result.json();

      const crmClients =
        getResult?.ClientList?.filter((item) => item.type === "Crm") || [];

      setClient(crmClients);
    } catch (error) {
      console.error("Get client error:", error);
      showAlert("error", error.message || "Unable to load clients.");
    }
  };

  useEffect(() => {
    getClient();
  }, []);

  const getClientOptionValue = (item, index = 0) => {
    return String(
      item.id ||
        item.clientId ||
        item.clientid ||
        item.mobile ||
        `${item.company || item.firstname || "client"}-${index}`,
    );
  };

  const getClientOptionLabel = (item) => {
    const clientName = `${item.firstname || ""} ${item.lastname || ""}`.trim();

    if (item.company && clientName) {
      return `${item.company} - ${clientName}`;
    }

    if (item.company) {
      return `${item.company} - ${item.mobile || ""}`;
    }

    return `${clientName || "Unnamed client"} - ${item.mobile || ""}`;
  };

  const handleBoots = async (event) => {
    const selectedClientId = event.target.value;

    setClientId(selectedClientId);

    if (!selectedClientId) {
      setClientid(null);
      return;
    }

    const selectedClient = client.find(
      (item, index) => getClientOptionValue(item, index) === selectedClientId,
    );

    if (!selectedClient || !selectedClient.regId) {
      setClientid(null);
      return;
    }

    try {
      const api = `${localApi}/register/find/byId/${selectedClient.regId}`;

      const result = await fetch(api, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
          Accept: "application/json",
        },
      });

      if (!result.ok) {
        throw new Error("Unable to load client details.");
      }

      const getResult = await result.json();

      setClientid(getResult || null);
    } catch (error) {
      console.error("Fetch client by regId error:", error);
      setClientid(null);
    }
  };

  const getUserTypes = useCallback(async () => {
    setLoadingTypes(true);

    try {
      const response = await fetch(`${localApi}/type/list`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Unable to load contact types.");
      }

      const result = await response.json();

      const filteredTypes =
        result?.TypeList?.filter(
          (item) =>
            item.title !== "Control" &&
            item.title !== "Admin" &&
            item.title !== "Crm",
        ) || [];

      setTypeList(filteredTypes);

      const countryResponse = await Axios.get(
        `${localApi}/countrylistcode/allList`,
        {
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      setCountryCodeList(countryResponse.data || []);
    } catch (error) {
      console.error("Type list error:", error);
      showAlert("error", error.message || "Unable to load contact types.");
    } finally {
      setLoadingTypes(false);
    }
  }, []);

  useEffect(() => {
    getUserTypes();
  }, [getUserTypes]);

  const getDuplicateEndpoint = (field, value) => {
    if (field === "mobile") {
      return `/contact/find/byMobile/${encodeURIComponent(value)}`;
    }

    if (field === "mobileWhatsapp") {
      return `/contact/find/byWhatsapp/${encodeURIComponent(value)}`;
    }

    if (field === "email") {
      return `/contact/find/byEmail/${encodeURIComponent(value)}`;
    }

    return null;
  };

  const getDuplicateMessage = (field) => {
    if (field === "mobile") {
      return "Mobile No. Already Registered";
    }

    if (field === "mobileWhatsapp") {
      return "Whatsapp No. Already Registered";
    }

    if (field === "email") {
      return "Email ID Already Registered";
    }

    return "Value Already Registered";
  };

  const responseMeansDuplicate = (result) => {
    const message =
      result?.message || result?.data?.message || result?.error || "";

    const text = String(message).trim();

    if (!text || /^not found$/i.test(text)) {
      return false;
    }

    return (
      /already\s*registered/i.test(text) ||
      /already\s*exist/i.test(text) ||
      /duplicate/i.test(text)
    );
  };

  const checkExistingValue = useCallback(async (field, value) => {
    const normalizedValue = String(value || "").trim();
    const endpoint = getDuplicateEndpoint(field, normalizedValue);

    if (!endpoint) {
      return false;
    }

    const requestId = validationRequestIds.current[field] + 1;
    validationRequestIds.current[field] = requestId;

    if (!normalizedValue) {
      setErrors((previous) => ({
        ...previous,
        [field]: "",
      }));

      setRegisteredStatus((previous) => ({
        ...previous,
        [field]: false,
      }));

      return false;
    }

    try {
      const response = await fetch(`${localApi}${endpoint}`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
          Accept: "application/json",
        },
      });

      const result = await response.json().catch(() => ({}));

      // Ignore an old response if another request was started afterward.
      if (validationRequestIds.current[field] !== requestId) {
        return false;
      }

      const isDuplicate = responseMeansDuplicate(result);
      const duplicateMessage = getDuplicateMessage(field);

      if (isDuplicate) {
        setErrors((previous) => ({
          ...previous,
          [field]: duplicateMessage,
        }));

        setRegisteredStatus((previous) => ({
          ...previous,
          [field]: true,
        }));

        return true;
      }

      setErrors((previous) => ({
        ...previous,
        [field]: "",
      }));

      setRegisteredStatus((previous) => ({
        ...previous,
        [field]: false,
      }));

      return false;
    } catch (error) {
      console.error(`${field} availability check failed:`, error);

      // Do not mark the value as duplicate on a network error.
      if (validationRequestIds.current[field] === requestId) {
        setRegisteredStatus((previous) => ({
          ...previous,
          [field]: false,
        }));
      }

      return false;
    }
  }, []);

  useEffect(() => {
    if (!form.mobile) {
      setErrors((previous) => ({
        ...previous,
        mobile: "",
      }));

      setRegisteredStatus((previous) => ({
        ...previous,
        mobile: false,
      }));

      return undefined;
    }

    const timer = setTimeout(() => {
      checkExistingValue("mobile", form.mobile);
    }, 500);

    return () => clearTimeout(timer);
  }, [form.mobile, checkExistingValue]);

  useEffect(() => {
    if (!form.mobileWhatsapp) {
      setErrors((previous) => ({
        ...previous,
        mobileWhatsapp: "",
      }));

      setRegisteredStatus((previous) => ({
        ...previous,
        mobileWhatsapp: false,
      }));

      return undefined;
    }

    const timer = setTimeout(() => {
      checkExistingValue("mobileWhatsapp", form.mobileWhatsapp);
    }, 500);

    return () => clearTimeout(timer);
  }, [form.mobileWhatsapp, checkExistingValue]);

  useEffect(() => {
    if (!form.email) {
      setErrors((previous) => ({
        ...previous,
        email: "",
      }));

      setRegisteredStatus((previous) => ({
        ...previous,
        email: false,
      }));

      return undefined;
    }

    const timer = setTimeout(() => {
      checkExistingValue("email", form.email);
    }, 500);

    return () => clearTimeout(timer);
  }, [form.email, checkExistingValue]);

  const handleMobileChange = (value, country) => {
    const normalizedValue = value || "";
    const isoCode = country?.countryCode || "in";

    setCountryCode(isoCode);

    setForm((previous) => {
      const whatsappWasSame =
        previous.mobileWhatsapp === previous.mobile ||
        previous.mobileWhatsapp === "";

      return {
        ...previous,
        mobile: normalizedValue,
        mobileWhatsapp: whatsappWasSame
          ? normalizedValue
          : previous.mobileWhatsapp,
      };
    });

    setErrors((previous) => ({
      ...previous,
      mobile: "",
      mobileWhatsapp: "",
    }));

    setRegisteredStatus((previous) => ({
      ...previous,
      mobile: false,
      mobileWhatsapp: false,
    }));
  };

  const handleWhatsappChange = (value) => {
    const normalizedValue = value || "";

    setForm((previous) => ({
      ...previous,
      mobileWhatsapp: normalizedValue,
      active: normalizedValue !== "" && normalizedValue === previous.mobile,
    }));

    setErrors((previous) => ({
      ...previous,
      mobileWhatsapp: "",
    }));

    setRegisteredStatus((previous) => ({
      ...previous,
      mobileWhatsapp: false,
    }));
  };

  const handleSameWhatsappChange = (event) => {
    const checked = event.target.checked;

    setForm((previous) => ({
      ...previous,
      mobileWhatsapp: checked ? previous.mobile : "",
      active: checked,
    }));

    setErrors((previous) => ({
      ...previous,
      mobileWhatsapp: "",
    }));

    setRegisteredStatus((previous) => ({
      ...previous,
      mobileWhatsapp: false,
    }));
  };

  const handleStateChange = (event) => {
    const selectedState = event.target.value;

    const selectedStateObject = states.find(
      (item) => item.name === selectedState,
    );

    setForm((previous) => ({
      ...previous,
      state: selectedState,
      city: "",
    }));

    setStateCode(selectedStateObject?.state_code || "");

    setErrors((previous) => ({
      ...previous,
      state: "",
      city: "",
    }));
  };

  const handleCityChange = (event) => {
    updateField("city", event.target.value);
  };

  const validatePhone = (value) => {
    if (!value) {
      return false;
    }

    try {
      const phoneNumber = parsePhoneNumber(`+${value}`);

      return Boolean(phoneNumber && isValidPhoneNumber(phoneNumber.number));
    } catch (error) {
      return false;
    }
  };

  const validateForm = () => {
    const nextErrors = {};

    if (!simpleTypeSelect) {
      nextErrors.type = "Please select a contact type.";
    }

    if (!form.mobile) {
      nextErrors.mobile = "Mobile number is required.";
    } else if (!validatePhone(form.mobile)) {
      nextErrors.mobile = "Enter a valid mobile number.";
    }

    if (form.mobileWhatsapp && !validatePhone(form.mobileWhatsapp)) {
      nextErrors.mobileWhatsapp = "Enter a valid WhatsApp number.";
    }

    if (form.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(form.email)) {
        nextErrors.email = "Enter a valid email address.";
      }
    }

    setErrors((previous) => ({
      ...previous,
      ...nextErrors,
    }));

    return Object.keys(nextErrors).length === 0;
  };

  const validateDuplicateFieldsBeforeSubmit = async () => {
    const valuesToCheck = [
      {
        field: "mobile",
        value: form.mobile,
      },
      {
        field: "mobileWhatsapp",
        value: form.mobileWhatsapp,
      },
      {
        field: "email",
        value: form.email,
      },
    ].filter(({ value }) => String(value || "").trim());

    const duplicateResults = await Promise.all(
      valuesToCheck.map(({ field, value }) => checkExistingValue(field, value)),
    );

    const duplicateIndex = duplicateResults.findIndex(Boolean);

    if (duplicateIndex !== -1) {
      const duplicateField = valuesToCheck[duplicateIndex].field;

      showAlert("error", getDuplicateMessage(duplicateField));

      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    if (!clientid) {
      showAlert("error", "Please select a company and client name.");
      return;
    }

    setSubmitting(true);

    // Always perform fresh server checks immediately before saving.
    const duplicatesAreValid = await validateDuplicateFieldsBeforeSubmit();

    if (!duplicatesAreValid) {
      setSubmitting(false);
      return;
    }

    const selectedType = typeList.find(
      (item) => item.title === simpleTypeSelect,
    );

    const countryObject = countryCodeList.find(
      (item) => item.countryCode?.toLowerCase() === countryCode.toLowerCase(),
    );

    if (!selectedType || !countryObject) {
      showAlert("error", "Invalid selection. Please try again.");
      setSubmitting(false);
      return;
    }

    const payload = {
      websitename: "indianbangles.in",
      typeId: selectedType.typeId,
      profit: selectedType.profit,
      type: selectedType.title,
      firstname: form.firstName ? form.firstName.trim() : null,
      lastname: form.lastName ? form.lastName.trim() : null,
      mobile: form.mobile,
      whatsapp: form.mobileWhatsapp ? form.mobileWhatsapp : null,
      email: form.email ? form.email.trim() : null,
      company: form.company ? form.company.trim() : null,
      city: form.city,
      state: form.state,
      country:
        countryObject.countryName?.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "") ||
        "",
      smsMarketing: true,
      countryCode: countryObject.countryCode,
      isoNumber: countryObject.isoNumber,
      url: form.url ? form.url : null,
      regAdminId: clientid.aId || "",
    };

    try {
      const response = await fetch(
        `${localApi}/contact/addRN/byCrmReferenceId/${clientid.id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${credentials}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(result?.message || "Unable to create CRM contact.");
      }

      setForm(initialForm);
      setSimpleTypeSelect("");
      setStateCode("");
      setClientid(null);
      setClientId("");
      setErrors({});
      setRegisteredStatus(initialRegisteredStatus);

      showAlert(
        "success",
        result?.message || "CRM contact created successfully.",
      );
    } catch (error) {
      console.error("Create contact error:", error);
      showAlert("error", error.message || "Unable to create CRM contact.");
    } finally {
      setSubmitting(false);
    }
  };

  const inputStyle = {
    width: "100%",
    border: "none",
    borderBottom: "1px solid #040000",
    borderRadius: 0,
  };

  const phoneContainerStyle = {
    width: "100%",
    paddingLeft: 12,
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={10} md={8}>
          <Card>
            <CardBody>
              <h4>Add CRM Contact</h4>

              {alert.open && (
                <SweetAlert
                  type={alert.type}
                  style={{
                    display: "block",
                    marginTop: "-100px",
                  }}
                  title={alert.message}
                  onConfirm={closeAlert}
                  confirmBtnCssClass={`${alertClasses.button} ${
                    alert.type === "success"
                      ? alertClasses.success
                      : alertClasses.danger
                  }`}
                />
              )}

              <form className={classes.form} onSubmit={handleSubmit} noValidate>
                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <FormControl
                    fullWidth
                    className={dropdownClasses.selectFormControl}
                  >
                    <Select
                      value={clientId}
                      onChange={handleBoots}
                      displayEmpty
                      classes={{
                        select: dropdownClasses.select,
                      }}
                      MenuProps={{
                        className: dropdownClasses.selectMenu,
                      }}
                      inputProps={{
                        name: "clientId",
                        id: "client-select",
                      }}
                      style={{ width: "100%" }}
                    >
                      <MenuItem value="" disabled>
                        <em>Select Company & Client Name...</em>
                      </MenuItem>

                      {client.map((item, index) => {
                        const optionValue = getClientOptionValue(item, index);

                        return (
                          <MenuItem
                            key={optionValue}
                            value={optionValue}
                            classes={{
                              root: dropdownClasses.selectMenuItem,
                              selected: dropdownClasses.selectMenuItemSelected,
                            }}
                          >
                            {getClientOptionLabel(item)}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>

                  {!clientid && (
                    <ErrorMessage message="Please select a company and client name." />
                  )}
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <FormControl
                    fullWidth
                    className={dropdownClasses.selectFormControl}
                    error={Boolean(errors.type)}
                  >
                    <InputLabel
                      htmlFor="simple-select"
                      className={dropdownClasses.selectLabel}
                    >
                      Select Type...
                    </InputLabel>

                    <Select
                      value={simpleTypeSelect}
                      onChange={(event) => {
                        setSimpleTypeSelect(event.target.value);

                        setErrors((previous) => ({
                          ...previous,
                          type: "",
                        }));
                      }}
                      classes={{
                        select: dropdownClasses.select,
                      }}
                      MenuProps={{
                        className: dropdownClasses.selectMenu,
                      }}
                      inputProps={{
                        name: "simpleTypeSelect",
                        id: "simple-Type-Select",
                      }}
                      style={{ width: "100%" }}
                    >
                      <MenuItem value="" disabled>
                        Select Type
                      </MenuItem>

                      {typeList.map((item) => (
                        <MenuItem
                          key={item.typeId || item.title}
                          value={item.title}
                          classes={{
                            root: dropdownClasses.selectMenuItem,
                            selected: dropdownClasses.selectMenuItemSelected,
                          }}
                        >
                          {item.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <ErrorMessage message={errors.type} />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className={classes.inputAdornment}
                        >
                          <Face className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      placeholder: "First Name...",
                    }}
                    id="firstName"
                    name="firstName"
                    value={form.firstName}
                    onChange={(event) =>
                      updateField("firstName", event.target.value)
                    }
                  />

                  <ErrorMessage message={errors.firstName} />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className={classes.inputAdornment}
                        >
                          <Face className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      placeholder: "Last Name...",
                    }}
                    id="lastName"
                    name="lastName"
                    value={form.lastName}
                    onChange={(event) =>
                      updateField("lastName", event.target.value)
                    }
                  />

                  <ErrorMessage message={errors.lastName} />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <PhoneInput
                    country={countryCode}
                    value={form.mobile}
                    onChange={handleMobileChange}
                    inputStyle={inputStyle}
                    containerStyle={phoneContainerStyle}
                    inputProps={{
                      id: "mobile",
                      name: "mobile",
                      required: true,
                    }}
                    enableSearch
                    disableSearchIcon
                  />

                  <ErrorMessage message={errors.mobile} />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <FormControlLabel
                    classes={{
                      root: classes.checkboxLabelControl,
                      label: classes.checkboxLabel,
                    }}
                    control={
                      <Checkbox
                        checked={
                          Boolean(form.mobile) &&
                          form.mobileWhatsapp === form.mobile
                        }
                        onChange={handleSameWhatsappChange}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot,
                        }}
                      />
                    }
                    label={
                      <span style={{ color: "#9c27b0" }}>
                        If your WhatsApp number is the same, click this
                        checkbox.
                      </span>
                    }
                  />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <PhoneInput
                    country={countryCode}
                    value={form.mobileWhatsapp}
                    onChange={handleWhatsappChange}
                    inputStyle={inputStyle}
                    containerStyle={phoneContainerStyle}
                    inputProps={{
                      id: "mobileWhatsapp",
                      name: "mobileWhatsapp",
                    }}
                    enableSearch
                    disableSearchIcon
                  />

                  <ErrorMessage message={errors.mobileWhatsapp} />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className={classes.inputAdornment}
                        >
                          <BusinessIcon
                            className={classes.inputAdornmentIcon}
                          />
                        </InputAdornment>
                      ),
                      placeholder: "Company...",
                    }}
                    id="company"
                    name="company"
                    value={form.company}
                    onChange={(event) =>
                      updateField("company", event.target.value)
                    }
                  />

                  <ErrorMessage message={errors.company} />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className={classes.inputAdornment}
                        >
                          <EmailIcon className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      placeholder: "Email...",
                      type: "email",
                    }}
                    id="email"
                    name="email"
                    value={form.email}
                    onChange={(event) =>
                      updateField("email", event.target.value)
                    }
                  />

                  <ErrorMessage message={errors.email} />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <FormControl
                    fullWidth
                    className={dropdownClasses.selectFormControl}
                    error={Boolean(errors.state)}
                  >
                    <InputLabel
                      htmlFor="state-select"
                      className={dropdownClasses.selectLabel}
                    >
                      Select State...
                    </InputLabel>

                    <Select
                      value={form.state}
                      onChange={handleStateChange}
                      disabled={!countryCode}
                      classes={{
                        select: dropdownClasses.select,
                      }}
                      MenuProps={{
                        className: dropdownClasses.selectMenu,
                      }}
                      inputProps={{
                        name: "state",
                        id: "state-select",
                      }}
                      style={{ width: "100%" }}
                    >
                      <MenuItem value="" disabled>
                        Select State
                      </MenuItem>

                      {states.map((item) => (
                        <MenuItem
                          key={item.state_code || item.name}
                          value={item.name}
                          classes={{
                            root: dropdownClasses.selectMenuItem,
                            selected: dropdownClasses.selectMenuItemSelected,
                          }}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <ErrorMessage message={errors.state} />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <FormControl
                    fullWidth
                    className={dropdownClasses.selectFormControl}
                    error={Boolean(errors.city)}
                  >
                    <InputLabel
                      htmlFor="city-select"
                      className={dropdownClasses.selectLabel}
                    >
                      Select City...
                    </InputLabel>

                    <Select
                      value={form.city}
                      onChange={handleCityChange}
                      disabled={!form.state}
                      classes={{
                        select: dropdownClasses.select,
                      }}
                      MenuProps={{
                        className: dropdownClasses.selectMenu,
                      }}
                      inputProps={{
                        name: "city",
                        id: "city-select",
                      }}
                      style={{ width: "100%" }}
                    >
                      <MenuItem value="" disabled>
                        Select City
                      </MenuItem>

                      {cities.map((item) => (
                        <MenuItem
                          key={item.name}
                          value={item.name}
                          classes={{
                            root: dropdownClasses.selectMenuItem,
                            selected: dropdownClasses.selectMenuItemSelected,
                          }}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <ErrorMessage message={errors.city} />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      placeholder: "URL...",
                    }}
                    id="url"
                    name="url"
                    value={form.url}
                    onChange={(event) => updateField("url", event.target.value)}
                  />

                  <ErrorMessage message={errors.url} />
                </GridItem>

                <GridItem xs={12} style={{ padding: "0 12px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: 24,
                    }}
                  >
                    <Button
                      color="primary"
                      type="submit"
                      disabled={submitting || loadingTypes}
                    >
                      {submitting ? "Saving..." : "Save Contact"}
                    </Button>
                  </div>
                </GridItem>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
